/**
 * Created by mestrad on 2018. 06. 28..
 */

export default Gallery;

const $ = jQuery;

function Gallery( config )
{
    function init(){

        if( ! document.getElementById("blueimp-gallery") ) {
            $("body").append($(
                '<div id="blueimp-gallery" class="blueimp-gallery">' +
                '<div class="slides"></div>' +
                '<h3 class="title"></h3>' +
                '<a class="prev">‹</a>' +
                '<a class="next">›</a>' +
                '<a class="close">×</a>' +
                '<a class="play-pause"></a>' +
                '<ol class="indicator"></ol>' +
                '</div>'
            ));
        }

        if(  document.getElementById('blueimp-gallery-nnpImages') ) {
            document.getElementById('blueimp-gallery-nnpImages').onclick = function (event) {
                event = event || window.event;
                var target = event.target || event.srcElement,
                    link = target.src ? target.parentNode : target,
                    options = {index: link, event: event},
                    links = this.getElementsByTagName( '.item > a' );
                blueimp.Gallery(links, options);
            };
        }
    }

    function destroy ()
    {
        $("#blueimp-gallery-nnpImages").remove();
    }

    function refresh ( data )
    {
        init();
    }

    return {
        refresh: refresh,
        destroy: destroy
    };
}
